import { render, staticRenderFns } from "./topicLists.vue?vue&type=template&id=6e45b809"
import script from "./topicLists.vue?vue&type=script&lang=js"
export * from "./topicLists.vue?vue&type=script&lang=js"
import style0 from "./topicLists.vue?vue&type=style&index=0&id=6e45b809&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports